import { ElementType } from 'react';
import { defineMessages, MessageDescriptor } from 'dibs-react-intl';

// components
import { SbRespRefineMenuFilterPrice } from './SbRespRefineMenuFilterPrice';
import { SbRespRefineMenuFilterCategory } from './SbRespRefineMenuFilterCategory';
import { SbRespRefineMenuFilterStoneCut } from './SbRespRefineMenuFilterStoneCut';
import { SbRespRefineMenuFilterDimensions } from './SbRespRefineMenuFilterDimensions';
import { SbRespRefineMenuFilterCaratWeight } from './SbRespRefineMenuFilterCaratWeight';
import { SbRespRefineMenuFilterDeliveryOptions } from './SbRespRefineMenuFilterDeliveryOptions';
import { sbSharedRefineMenuFiltersMap } from '../../SbSharedRefineMenu/SbSharedRefineMenuFilters/sbSharedRefineMenuFiltersMap';

const titleOverrides = defineMessages({
    dimensions: {
        id: 'sb.SbRespRefineMenuFilterDimension.title',
        defaultMessage: 'Dimensions',
    },
    location: {
        id: 'sb.SbRespRefineMenuFilterDeliveryOptions.title',
        defaultMessage: 'Shipping Options',
    },
});

type FilterConfigType = {
    component?: ElementType | null;
    title?: MessageDescriptor;
    isBatchAppliedFilter?: boolean;
};

export const sbRespRefineMenuFiltersMap: Record<string | symbol, FilterConfigType> = {
    ...sbSharedRefineMenuFiltersMap,
    categoryL1: {
        component: SbRespRefineMenuFilterCategory,
    },
    'carat-weight': {
        component: SbRespRefineMenuFilterCaratWeight,
    },
    height: {
        component: SbRespRefineMenuFilterDimensions,
        title: titleOverrides.dimensions,
    },
    width: {
        component: SbRespRefineMenuFilterDimensions,
        title: titleOverrides.dimensions,
    },
    length: {
        component: SbRespRefineMenuFilterDimensions,
        title: titleOverrides.dimensions,
    },
    depth: {
        component: SbRespRefineMenuFilterDimensions,
        title: titleOverrides.dimensions,
    },
    price: {
        component: SbRespRefineMenuFilterPrice,
    },
    priceTrade: {
        component: SbRespRefineMenuFilterPrice,
    },
    'stone-cut': {
        component: SbRespRefineMenuFilterStoneCut,
    },
    latest: {
        component: null,
        isBatchAppliedFilter: true,
    },
    location: {
        component: SbRespRefineMenuFilterDeliveryOptions,
        title: titleOverrides.location,
    },
    sale: {
        component: null,
        isBatchAppliedFilter: true,
    },
    customizable: {
        component: null,
        isBatchAppliedFilter: true,
    },
    'net-price': {
        component: null,
        isBatchAppliedFilter: true,
    },
    returnable: {
        component: null,
        isBatchAppliedFilter: true,
    },
    recognized: {
        component: null,
        isBatchAppliedFilter: true,
    },
    topSeller: {
        component: null,
        isBatchAppliedFilter: true,
    },
    isSellerStrategicPartner: {
        component: null,
        isBatchAppliedFilter: true,
    },
    view: {
        component: null,
        isBatchAppliedFilter: true,
    },
};

type ValidatableAppliedFilterType = {
    canBeDismissed: boolean | null;
};
export const getValidRespAppliedFilters = function <T>({
    appliedFilters,
}: {
    appliedFilters: ReadonlyArray<(T & ValidatableAppliedFilterType) | null>;
}): ReadonlyArray<(T & ValidatableAppliedFilterType) | null> {
    return appliedFilters?.filter(filter => filter?.canBeDismissed) || [];
};

export const isBatchAppliedFilter = (filterName: string): boolean =>
    sbRespRefineMenuFiltersMap[filterName] &&
    !!sbRespRefineMenuFiltersMap[filterName]?.isBatchAppliedFilter;
